import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Collapse } from 'reactstrap';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import CheckoutProcess from './Detail/CheckoutProcess';
import FormShipping from './Detail/FormShipping';
import FormPayment from './Detail/FormPayment';
import PaymentOffer from '../PageOffer/PaymentOffer';
import { Button } from '../Forms';
import Loading from '../../components/Loading';
import {
  BANKTRANSFER,
  CREDITCARD,
  KREDIVO,
  AKULAKU,
  FULLWALLET,
  VIRTUALACCOUNT,
  BCA_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA,
  BCA_INSTALLMENTS,
  GOPAY,
  BCA_CREDIT_CARD,
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  ATOME
} from '../../constants/paymentMethods';
import { convertOftheDay } from '../../utils';
import ShippingFlateRateInfo from './ShippingFlatRateInfo';
import NextIcon from "../../images/global-next-icon.png";

export const defaultCreditCard = ~document.location.hostname.indexOf("www.kickavenue.com") ? BCA_CREDIT_CARD : CREDITCARD;
export default class BottomSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _collapseShipping: false,
      _collapsePayment: false,
      _collapseShippingReturn: false,
      openVoucherModal: false,
      selectedVoucherCode: null
    }

    this.shippingToggle = this.shippingToggle.bind(this);
    this.paymentToggle = this.paymentToggle.bind(this);
    this.shippingReturnToggle = this.shippingReturnToggle.bind(this);
  }

  shippingToggle() {
    this.setState({
      _collapseShipping: !this.state._collapseShipping
    })
  }

  paymentToggle() {
    this.setState({
      _collapsePayment: !this.state._collapsePayment
    })
  }

  shippingReturnToggle() {
    this.setState({
      _collapseShippingReturn: !this.state._collapseShippingReturn
    })
  }

  toggleVoucherModal = () => {
    this.setState({
      openVoucherModal: !this.state.openVoucherModal,
    });
  };

  handleSelectedVoucherCode = (data) => {
    this.setState({ selectedVoucherCode: data })
  }

  _paymentMethod = () => {
    switch (this.props._paymentType) {
      case BANKTRANSFER: return 'Bank Transfer'
      case MANDIRI_CREDIT_CARD: return "Mandiri Credit Card"
      case MANDIRI_DEBIT_CARD: return "Mandiri Debit Card"
      case BNI_CREDIT_CARD: return "BNI Credit Card"
      case BNI_DEBIT_CARD: return "BNI Debit Card"
      case BCA_CREDIT_CARD: return "BCA Credit Card / Debit Card"
      case CREDITCARD: return 'Credit Card'
      case FULLWALLET: return 'Kick Credit'
      case BCA_VA: return 'BCA (Virtual Account)'
      case BNI_VA: return 'BNI (Virtual Account)'
      case PERMATA_VA: return 'PERMATA (Virtual Account)'
      case MANDIRI_VA: return 'MANDIRI (Virtual Account)'
      case VIRTUALACCOUNT: return 'Virtual Account'
      case KREDIVO: return 'Kredivo Installments'
      case ATOME: return 'Atome Installments'
      case AKULAKU: return 'Akulaku Installments'
      case GOPAY: return 'Gopay'
      case BCA_INSTALLMENTS: return 'BCA Installments'

      default: return 'Bank Transfer'
    }
  }

  render() {
    const { data } = this.props.dataPostalCode.shippingHistory;
    const { product } = this.props;
    const urlProduct = product.vintage? `${this.props.match.url}?vintage=true` : this.props.match.url;

    return (
      <div ref={ref => this.containerRefs = ref}>
        <WrapperDescription>
          <Row className="row-bottom-section" onClick={this.shippingToggle}>
            <Col xs={10} style={{ paddingLeft: 0 }}>
              <Title>Ship to: </Title>
              {
                (this.props._fullName === undefined && this.props._alamat === undefined) || (this.props._fullName === "" && this.props._alamat === "") ?
                  <span className="input-shipping">Please input a shipping address.</span> :
                  <div>
                    <Description>{this.props._fullName}</Description>
                    <Description>{this.props._alamat}</Description>
                  </div>
              }
            </Col>
            <Col className="col-bottom-section" xs={2}>
              <span>EDIT</span>
            </Col>
          </Row>
          <Collapse isOpen={this.state._collapseShipping}>
            <FormShipping
              {...this.props}
            />
          </Collapse>
          {
            !this.props.pageOffer && (
              <Row className="row-bottom-section">
                <Col xs={10} style={{ paddingLeft: 0 }}>
                  <Title>Have voucher code? </Title>
                </Col>
                <div className="voucher-wrapper">
                  <div className="title-name">
                    <p>Voucher Code</p>
                  </div>
                  <div
                    className="voucher-right-content"
                    onClick={this.toggleVoucherModal}
                  >
                    <div className="text-wrapper">
                      <p>{this.state.selectedVoucherCode ? `${this.state.selectedVoucherCode.code}` : "Enter voucher code here"}</p>
                    </div>
                    <div className="image-wrapper">
                      <KickImage src={NextIcon} alt="next-icon" />
                    </div>
                  </div>
                </div>
              </Row>
            )
          }
          <Row className="row-bottom-section" onClick={this.paymentToggle}>
            <Col xs={10} style={{ paddingLeft: 0 }}>
              <Title>Payment: </Title>
              <Description>{this._paymentMethod()}</Description>
            </Col>
            <Col className="col-bottom-section" xs={2}>
              <span>EDIT</span>
            </Col>
          </Row>
          <Collapse isOpen={this.state._collapsePayment}>
            {
              this.props.pageOffer ?
                <PaymentOffer
                  {...this.props}
                /> :
                <FormPayment
                  {...this.props}
                  toggleVoucherModal={this.toggleVoucherModal}
                  openVoucherModal={this.state.openVoucherModal}
                  handleSelectedVoucherCode={this.handleSelectedVoucherCode}
                />
            }
          </Collapse>
          {
            this.props.isErrorShippingFetch && (
              <div style={{ padding: '.5rem 0px', color: '#dc3545' }}>
                <span>
                  Failed to calculate your shipping.{' '}
                  <a href="#" onClick={this.props.onRetryCalculateShippingFee} style={{ textDecoration: 'underline' }}>Retry now</a>
                </span>
              </div>
            )
          }
          <Row onClick={this.shippingReturnToggle} style={{ cursor: 'pointer', paddingTop: '15px' }}>
            <Col>
              <Title>Shipping and Returns</Title>
            </Col>
          </Row>
          <Description>
            {this.props.product && this.props.product.product && (
              <ShippingFlateRateInfo isApparels={this.props.product.product.category.name.toLowerCase() === 'apparels'} />
            )}
          </Description>
          <Description>
            We DO NOT accept returns on special items, vintages, samples (including friends and families), aforementioned defected items or any pre-owned items.
                (Please make sure you have carefully inspect the conditions of the pre-owned should you choose to buy them).<br />
                There is limit of 2 days after you receive the items to request a return. Please contact our Customer Service at info@kickavenue.com or Whatsapp +6281210005425. <br />
                Items must be in the condition they were in when sent by Kick Avenue, failure to meet this condition will result in rejection to claim your return.
            </Description>
          {/* </Collapse> */}
          <SmallNotes>By clicking Buy, user has read and agreed to Kick Avenue Terms and Conditions</SmallNotes>
        </WrapperDescription>
        <Row>
          <Col style={{ marginTop: '15px' }}>
            {this.props._renderError()}
          </Col>
        </Row>
        <Row>
          {
            this.props.pageOffer ? null :
              <Col>
                {
                  this.props.dataPayments.payments.isSubmit || this.props._shouldRedirect ? <Loading center /> :
                    <div className="button-shipping-wrapper" style={{ marginBottom: '15px' }}>
                      <Button onClick={this.props._onSubmit} className="btn-green" color="secondary">BUY</Button>
                    </div>
                }
                <Link to={urlProduct} replace>
                  <Button className="btn-white flat">BACK TO PRODUCT</Button>
                </Link>
              </Col>
          }
        </Row>
      </div>
    )
  }
}

const WrapperDescription = styled.div`
  width: 100%;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  margin: 15px 0px 0px 0px;
`;

const ButtonWrapper = styled.div`
    display: inline-block; 
    margin-right: 10px;
    margin-top: 10px;
    width: 120px
`

const Title = styled.p`
    font-weight: 900;
    font-family: 'Nunito Bold';
    margin-bottom: .5rem!important;
`

const Description = styled.div`
    margin-bottom: .5em
`

const SmallNotes = styled.p`
    font-style: italic;
    font-size: 11px;
    color: #bbb;
    direction:rtl;
    text-align:justify;
`